import type { ReservedAsset } from '@/services/cart';

export interface TransfersShippingCartItem {
  key: string;
  name: string;
  lin: string;
  nsn: string;
  catalogId: string | null;
  sizeLabel: string | null;
  assetIds: string[];
  quantity: number;
}

const normalizeText = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

export const groupTransfersShippingCartItems = (
  assets: ReservedAsset[],
): TransfersShippingCartItem[] => {
  const groups = new Map<
    string,
    Omit<TransfersShippingCartItem, 'quantity'> & { quantity?: never }
  >();

  for (const reserved of assets) {
    const entity = reserved.entity;

    const name =
      normalizeText(entity.display_name) ??
      normalizeText(entity.entity_data?.asset_name) ??
      'Unknown';
    const lin = normalizeText(entity.entity_data?.lin) ?? '—';
    const nsn = normalizeText(entity.entity_data?.nsn) ?? '—';
    const catalogId = normalizeText(entity.entity_data?.catalog_id);
    const sizeLabel = normalizeText(reserved.size);

    const key = `${catalogId ?? 'no-catalog'}|${name}|${lin}|${nsn}|${sizeLabel ?? ''}`;

    const existing = groups.get(key);
    if (existing) {
      existing.assetIds.push(entity.id);
    } else {
      groups.set(key, {
        key,
        name,
        lin,
        nsn,
        catalogId: catalogId ?? null,
        sizeLabel,
        assetIds: [entity.id],
      });
    }
  }

  return Array.from(groups.values()).map((value) => ({
    ...value,
    quantity: value.assetIds.length,
  }));
};
